module.exports = __webpack_public_path__ + "media/images/online/top/plan/plan-detail-background-cd01b282e142c7b82a8437ca5ccdd6ef.jpg";